import { favoriteListQueryKeys as e } from "./favoriteListQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { favoriteListsApi as n } from "@maat/api-main";
import { useIsAuthenticated as r } from "@maat/store-auth";
//#region src/favoriteLists/useFavoriteListsQuery.ts
var i = () => {
	let i = r();
	return t({
		queryKey: e.list(),
		queryFn: () => n.getLists(),
		enabled: i
	});
};
//#endregion
export { i as useFavoriteListsQuery };
